<template>
    <div class="c-grid-cars-controls__wrap">
        <div class="o-container -full">
            <div class="c-grid-cars-controls">
                <div class="c-grid-cars-controls__left">
                    <div class="c-grid-cars-filter-closed">
                        <button class="o-button-filters-toggle" @click="toggle();">
                            <span class="c-showroom-2025-toggle__closed">
                                <svgIco icon="cars-filters" />
                                
                                Filtrer
                            </span>
                            <span class="c-showroom-2025-toggle__opened">
                                <svgIco icon="close" />
                            </span>
                        </button>
                    </div>
                </div>
                <div class="c-grid-cars-controls__right">
                    <div class="c-grid-cars-controls__keywords">
                        <span class="o-button-cars-filter" v-for="make in selectedMakes" :key="make">
                            {{make}}
                            <button><svgIco icon="close" @click="remove(make)" /></button>
                        </span>
                        
                        <button v-if="selectedMakes.length" class="c-button-cars-filter-reset o-button" @click="reset()">
                            <svgIco icon="trash" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="c-cars-sidebar__wrap">
        <div class="c-cars-sidebar">
            <div class="c-cars-sidebar__inner">
                <h3 class="c-cars-sidebar__title">Marques</h3>
                <div class="c-cars-sidebar__group">
                    
                    <label class="c-cars-sidebar__label" v-for="make in makes" :key="make"><input type="checkbox" @click="toggleMake"><span>{{ make }}</span></label>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'ShowroomFilters',
    props: {
        makesstr: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            selectedMakes: [],
        }
    },
    computed: {
        makes() {
            return this.makesstr.split(',').map(make => {
                return make.charAt(0).toUpperCase() + make.slice(1);
            });
        }
    },
    watch: {
        
    },

    methods: {
        toggle() {
            //data-target=".js-showroom-2025" data-class="is-sidebar-mobile-active" data-module="ClassToggle"
            const filters = document.querySelector('.js-showroom-2025');
            filters.classList.toggle('is-sidebar-mobile-active');
        },
        reset() {
            this.selectedMakes = [];
            this.exec();
        },
        remove(make) {
            this.selectedMakes = this.selectedMakes.filter(item => item !== make);
            this.exec();
        },
        toggleMake(event) {
            
            const make = event.target.nextElementSibling.innerText;
            if (event.target.checked) {
                this.selectedMakes.push(make);
            } else {
                this.selectedMakes = this.selectedMakes.filter(item => item !== make);
            }
            this.exec()
        },

        exec() {
            if (this.selectedMakes.length) {
                document.querySelectorAll('.c-showroom-2025__brand').forEach(item => {
                    item.style.display = 'none';
                });
                this.selectedMakes.forEach(make => {
                    console.log(make);
                    // Convert make to lowercase to match the ID
                    make = make.toLowerCase();
                    console.log(make);
                    document.querySelector('#marque-'+make.toLowerCase()).style.display = 'block';
                });
            } else {
                document.querySelectorAll('.c-showroom-2025__brand').forEach(item => {
                    item.style.display = 'block';
                });
            }
        }
        
    }
}
</script>
